<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="error white--text">
        Cash Flow Transactions
        <v-spacer></v-spacer>
        <v-btn
          v-if="sales.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-title>
            <div>
              <cashDisplay
                :isloading="isloading"
                :Balance="TotalBalance"
              ></cashDisplay>
            </div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              single-line
              hide-details
              class="d-print-none"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :hide-default-footer="hideFooter"
            flat
            :headers="headers"
            :items="sales"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <!-- <div class="flex-grow-1"></div> -->
                <searchDate
                  :searching="searching"
                  :SearchFun="OnSearch"
                ></searchDate>
                <v-spacer></v-spacer>
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="TotalSale"
                  ></cashDisplay>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.in`]="{ item }">
              <div v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </div>
            </template>
            <template v-slot:[`item.out`]="{ item }">
              <div v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import axios from "axios";
export default {
  components: {
    cashDisplay: () => import("@/components/coman/cashView"),
    searchDate: () => import("@/components/util/searchDate.vue"),
  },
  data() {
    return {
      BaseURL: "/qarash/qaas",
      searching: false,
      isloading: false,
      hideFooter: false,
      search: "",
      fromDate: "",
      toDate: "",
      sales: [],
      TotalBalance: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Description", value: "FullName" },
        { text: "IN", value: "in" },
        { text: "OUT", value: "out" },
        { text: "Account", value: "AccountName" },
        { text: "Details", value: "Details" },
        // { text: "Dr/Cr", value: "Acc" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    };
  },
  computed: {
    TotalSale() {
      if (!this.sales.length) return [];
      return [
        {
          Amount: this.sales.reduce((t, s) => {
            if (s.AmountType == "KES") return (t += s.Amount);
            return t;
          }, 0),
          AmountType: "KES",
        },
        {
          Amount: this.sales.reduce((t, s) => {
            if (s.AmountType == "USD") return (t += s.Amount);
            return t;
          }, 0),
          AmountType: "USD",
        },
      ];
    },
  },
  methods: {
    async PrintPage() {
      this.hideFooter = true;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.hideFooter = false;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];
      this.TotalBalance = [];

      this.searching = true;
      this.isloading = true;
      let balanceReq = `${this.BaseURL}/balance`;

      axios
        .all([this.GetReq(), this.GetReq(balanceReq, { from, to })])
        .then(result => {
          // console.log(result);
          this.isloading = false;
          this.searching = false;
          this.sales = result[0].data;
          this.TotalBalance = result[1].data;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },
    GetReq(url, query) {
      if (!url) url = this.BaseURL + "/dailyBook";
      if (!query) query = { from: this.fromDate, to: this.toDate };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    loadSales(from, to) {
      try {
        // this.$store
        //   .dispatch("GET_ONLY", this.BaseURL)
        this.searching = true;
        this.isloading = true;
        let balanceReq = `${this.BaseURL}/balance`;

        axios
          .all([this.GetReq(), this.GetReq(balanceReq, { from, to })])
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value[0].data;
            this.TotalBalance = value[1].data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    const { date } = this.Current();
    this.fromDate = date;
    this.toDate = date;
    this.loadSales(date, date);
  },
};
</script>
